import { render } from "./RecommendFund.vue?vue&type=template&id=b185fbe8&scoped=true"
import script from "./RecommendFund.vue?vue&type=script&lang=js"
export * from "./RecommendFund.vue?vue&type=script&lang=js"

import "./RecommendFund.vue?vue&type=style&index=0&id=b185fbe8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b185fbe8"]])

export default __exports__